import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const fetchSpaceList = createAsyncThunk("fetchSpaceList", async () => {
	const response = await axiosHttp.get("/dms/spaces");
	return response.data;
});

export const createSpace = createAsyncThunk("createSpace", async (data) => {
	const response = await axiosHttp.post("/dms/space", data);
	return response.data;
});

export const updateSpace = createAsyncThunk("updateSpace", async ({id, data}) => {
	const response = await axiosHttp.put(`/dms/space/${id}`, data);
	return response.data;
});

export const deleteSpace = createAsyncThunk("deleteSpace", async (id) => {
	const response = await axiosHttp.delete(`/dms/space/${id}`);
	return response.data;
});

export const fetchSpaceDetail = createAsyncThunk("fetchSpaceDetail", async (id) => {
	const response = await axiosHttp.get(`/dms/space/${id}`);
	return response.data;
});

export const assignUsersToSpace = createAsyncThunk("assignUsersToSpace", async ({id, data}) => {
	const response = await axiosHttp.post(`/dms/space/${id}/assign-users`, data);
	return response.data;
});

export const makeAdmin = createAsyncThunk("makeAdmin", async ({id, data}) => {
	const response = await axiosHttp.post(`/dms/space/${id}/make-admin`, data);
	return response.data;
});

//get my spaces
export const getMySpaces = createAsyncThunk("getMySpace", async () => {
	const response = await axiosHttp.get("/dms/my-spaces");
	return response.data;
});

// Check if user is admin of a space
export const checkAdmin = createAsyncThunk("checkAdmin", async (spaceId) => {
	if (!spaceId) {
		return false;
	}
	const response = await axiosHttp.get(`/dms/check-admin/${spaceId}`);
	return response.data;
});

const spaceSlice = createSlice({
	name: "dmsSpaceSlice",
	initialState: {
          list:{
			data:null,
			isLoading:false,
			isError:false,
			error:null,
          },
		detail:{
			data:null,
			isLoading:false,
			isError:false,
			error:null,
			showDrawer:false,
			id:null,
		},
		mySpace:{
			data:null,
			isLoading:true,
			isError:false,
			error:null,
			selectedSpace:null,
			isAdmin:false,
			checkingAdmin:false,
		},
          create:{
			isLoading:false,
			isError:false,
			error:null,
			data:null,
          },
          update:{
			isLoading:false,
			isError:false,
			error:null,
			data:null,
			id:null,
          },
          delete:{
			isLoading:false,
			isError:false,
			error:null,
			data:null,
			id:null,
          },
		assignUsersToSpace:{
			isLoading:false,
			isError:false,
			error:null,
			data:null,
			id:null,
		},
		makeAdmin:{
			isLoading:false,
			isError:false,
			error:null,
			data:null,
			id:null,
		},
		createUpdateModal: {
			id: null,        // set when updating an existing object
			isModalOpen: false,
		},
		assignUsersModal: {
			id: null,
			isModalOpen: false,
		},
	},
	reducers: {
		showEditModal: (state, action) => {
			state.createUpdateModal.isModalOpen = true;
			state.createUpdateModal.id = action.payload;
		},
		hideEditModal: (state) => {	
			state.createUpdateModal.isModalOpen = false;
			state.createUpdateModal.id = null;
		},
		showCreateModal: (state) => {
			state.createUpdateModal.isModalOpen = true;
			state.createUpdateModal.id = null;
		},
		hideCreateModal: (state) => {
			state.createUpdateModal.isModalOpen = false;
			state.createUpdateModal.id = null;
		},
		showAssignUsersModal: (state, action) => {
			state.assignUsersModal.isModalOpen = true;
			state.assignUsersModal.id = action.payload;
		},
		hideAssignUsersModal: (state) => {
			state.assignUsersModal.isModalOpen = false;
			state.assignUsersModal.id = null;
		},
		showSpaceDetailDrawer: (state, action) => {
			state.detail.showDrawer = true;
			state.detail.id = action.payload;
		},
		hideSpaceDetailDrawer: (state) => {
			state.detail.showDrawer = false;
			state.detail.id = null;
		},
		selectSpace: (state, action) => {
			state.mySpace.selectedSpace = action.payload;
		},
	},
	extraReducers: (builder) => {
          builder.addCase(fetchSpaceList.pending, (state, action) => {
			state.list.isLoading = true;
			state.list.isError = false;
			state.list.error = null;
		});
		builder.addCase(fetchSpaceList.fulfilled, (state, action) => {
			state.list.isLoading = false;
			state.list.isError = false;
			state.list.error = null;
			state.list.data = action.payload;
		});
		builder.addCase(fetchSpaceList.rejected, (state, action) => {
			state.list.isLoading = false;
			state.list.isError = true;
			state.list.error = action.payload;
		});

        builder.addCase(createSpace.pending, (state, action) => {
			state.create.isLoading = true;
			state.create.isError = false;
			state.create.error = null;
		});
		builder.addCase(createSpace.fulfilled, (state, action) => {
			state.create.isLoading = false;
			state.create.isError = false;
			state.create.error = null;
			state.create.data = action.payload;
			state.createUpdateModal.isModalOpen = false;
		});
		builder.addCase(createSpace.rejected, (state, action) => {
			state.create.isLoading = false;
			state.create.isError = true;
			state.create.error = action.payload;
		});
		builder.addCase(updateSpace.pending, (state, action) => {
			state.update.isLoading = true;
			state.update.isError = false;
			state.update.error = null;
		});
		builder.addCase(updateSpace.fulfilled, (state, action) => {
			state.update.isLoading = false;
			state.update.isError = false;
			state.update.error = null;
			state.update.data = action.payload;
			state.createUpdateModal.isModalOpen = false;
		});
		builder.addCase(updateSpace.rejected, (state, action) => {
			state.update.isLoading = false;
			state.update.isError = true;
			state.update.error = action.payload;

		});
		builder.addCase(deleteSpace.pending, (state, action) => {
			state.delete.isLoading = true;
			state.delete.isError = false;
			state.delete.error = null;
		});
		builder.addCase(deleteSpace.fulfilled, (state, action) => {
			state.delete.isLoading = false;
			state.delete.isError = false;
			state.delete.error = null;
			state.delete.data = action.payload;
		});
		builder.addCase(deleteSpace.rejected, (state, action) => {
			state.delete.isLoading = false;
			state.delete.isError = true;
			state.delete.error = action.payload;
		});
		builder.addCase(fetchSpaceDetail.pending, (state, action) => {
			state.detail.isLoading = true;
			state.detail.isError = false;
			state.detail.error = null;
		});
		builder.addCase(fetchSpaceDetail.fulfilled, (state, action) => {
			state.detail.isLoading = false;
			state.detail.isError = false;
			state.detail.error = null;	
			state.detail.data = action.payload;
		});
		builder.addCase(fetchSpaceDetail.rejected, (state, action) => {
			state.detail.isLoading = false;
			state.detail.isError = true;
			state.detail.error = action.payload;
		});

		builder.addCase(assignUsersToSpace.pending, (state, action) => {
			state.assignUsersToSpace.isLoading = true;
			state.assignUsersToSpace.isError = false;
			state.assignUsersToSpace.error = null;
		});
		builder.addCase(assignUsersToSpace.fulfilled, (state, action) => {
			state.assignUsersToSpace.isLoading = false;
			state.assignUsersToSpace.isError = false;
			state.assignUsersToSpace.error = null;
			state.assignUsersModal.isModalOpen = false;
			state.assignUsersModal.id = null;
		});
		builder.addCase(assignUsersToSpace.rejected, (state, action) => {
			state.assignUsersToSpace.isLoading = false;
			state.assignUsersToSpace.isError = true;
			state.assignUsersToSpace.error = action.payload;
		});
		builder.addCase(makeAdmin.pending, (state, action) => {
			state.makeAdmin.isLoading = true;
			state.makeAdmin.isError = false;
			state.makeAdmin.error = null;
			state.makeAdmin.data = null;
		});
		builder.addCase(makeAdmin.fulfilled, (state, action) => {
			state.makeAdmin.isLoading = false;
			state.makeAdmin.isError = false;
			state.makeAdmin.data = action.payload;
		});
		builder.addCase(makeAdmin.rejected, (state, action) => {
			state.makeAdmin.isLoading = false;
			state.makeAdmin.isError = true;
			state.makeAdmin.error = action.payload;
		});
		builder.addCase(getMySpaces.pending, (state, action) => {
			state.mySpace.isLoading = true;
			state.mySpace.isError = false;
			state.mySpace.error = null;
			state.mySpace.data = null;
		});
		builder.addCase(getMySpaces.fulfilled, (state, action) => {
			state.mySpace.isLoading = false;
			state.mySpace.isError = false;
			state.mySpace.error = null;
			state.mySpace.data = action.payload;
		});
		builder.addCase(getMySpaces.rejected, (state, action) => {
			state.mySpace.isLoading = false;
			state.mySpace.isError = true;
			state.mySpace.error = action.payload;
		});
		builder.addCase(checkAdmin.pending, (state, action) => {
			state.mySpace.checkingAdmin = true;
		});
		builder.addCase(checkAdmin.fulfilled, (state, action) => {
			state.mySpace.checkingAdmin = false;
			// Handle both boolean and string responses
			const result = action.payload;
			state.mySpace.isAdmin = result === true || result === 'true' || (typeof result === 'object' && result?.is_admin === true);
		});
		builder.addCase(checkAdmin.rejected, (state, action) => {
			state.mySpace.checkingAdmin = false;
			state.mySpace.isAdmin = false;
		});
	},
});

export const { showEditModal, hideEditModal, showCreateModal, hideCreateModal, showAssignUsersModal, hideAssignUsersModal, showSpaceDetailDrawer, hideSpaceDetailDrawer, selectSpace } = spaceSlice.actions;
export default spaceSlice.reducer;
